import { render, staticRenderFns } from "./detailSensorsTankCustomer.vue?vue&type=template&id=22b0afee&"
import script from "./detailSensorsTankCustomer.vue?vue&type=script&lang=js&"
export * from "./detailSensorsTankCustomer.vue?vue&type=script&lang=js&"
import style0 from "./detailSensorsTankCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports